<template>
  <div class="flex flex-col w-8/12 mx-auto">
    <div>
      <label class="font-semibold text-md text-grey-700">
        {{ $t('frontend_groovemail_leads_import_multiple_leads_question_confirm_ownership') }}
      </label>
    </div>
    <div class="mb-4">
      <label class="font-semibold text-sm text-grey-600">
        {{ $t('frontend_groovemail_leads_import_multiple_leads_enter_email_address_warning') }}
      </label>
    </div>
    <div class="bg-white rounded py-4 shadow">
      <div class="flex justify-between items-center border-b border-grey-100 p-2">
        <div class="w-1/3 px-2 py-1">
          <p class="text-sm font-bold text-grey-700">
            {{
              $t('frontend_groovemail_leads_import_multiple_leads_website_url_key')
            }}
          </p>
        </div>
        <div class="flex w-2/3 items-center">
          <div class="w-6/12 flex justify-start">
            <p class="text-sm font-bold text-grey-700">
              {{
                $t('frontend_groovemail_leads_import_multiple_leads_enter_email_address_header')
              }}
            </p>
          </div>
        </div>
      </div>
      <div
        v-for="(url, urlIndex) in localModel.websiteUrls"
        :key="urlIndex"
        class="flex justify-between items-center border-b border-grey-100 p-2"
      >
        <div class="w-1/3 px-2 py-1">
          <p class="text-sm font-semibold">{{ url.mainUrl }}</p>
        </div>
        <div
          class="flex w-2/3 items-center"
        >
          <div class="w-3/12 flex justify-end">
            <text-input
              variant="base"
              v-model="url.email"
              @input="emailEntered(urlIndex)"
              :placeholder="$t('frontend_groovemail_leads_import_multiple_leads_enter_email_address_header')"
              :disabled="url.verified === 1"
            />
          </div>
          <div class="w-6/12 flex justify-end">
            <p class="text-sm font-semibold pl-2">@{{ url.domain }}</p>
          </div>
          <div class="w-3/12 flex justify-end ml-2"
            v-if="url.verificationSendMailCount === 0"
            :class="{ 'cursor-not-allowed': url.sendDisabled }"
          >
            <gd-button
              size="auto"
              variant="primary"
              class="ml-2"
              :class="{ 'pointer-events-none': url.sendDisabled }"
              :disabled="url.sendDisabled"
              @click="sendVerificationMail(url, urlIndex)"
            >
              {{ $t('frontend_send') }}</gd-button
            >
          </div>
          <div class="w-2/12 flex justify-end ml-2"
            v-if="url.verificationSendMailCount > 0 && !url.verified"
            :class="{ 'cursor-not-allowed': url.sendDisabled }"
          >
            <gd-button
              variant="primary"
              size="auto"
              @click="sendVerificationMail(localModel.websiteUrls[currentWebsiteIndex], currentWebsiteIndex)"
              class="ml-2"
            >
              {{ $t('frontend_groovemail_import_leads_process_email_verification_resend_btn_text') }}
            </gd-button>
          </div>
          <div class="w-2/12 flex justify-end"
            v-if="url.verificationSendMailCount > 0 && url.verified"
          >
            <p class="text-sm text-success uppercase font-semibold">{{
              $t('frontend_groovemail_import_leads_process_email_verification_verfied')
            }}</p>
            <!-- <p v-else class="text-sm text-danger uppercase font-semibold">{{
              $t('frontend_groovemail_import_leads_process_email_verification_unverfied')
            }}</p> -->
          </div>
        </div>
      </div>
    </div>
    <p
      v-if="stepSaved && !allEmailsVerified"
      class="text-sm text-danger"
    >
      {{
        this.$t(
          'frontend_groovemail_leads_import_multiple_leads_question_confirm_ownership_attribute'
        )
      }}
    </p>
    <gd-modal
      id="email-verification-modal"
      name="email-verification-modal"
      :title="
        $t('frontend_groovemail_import_leads_process_email_verification_header')
      "
    >
      <div class="p-6">
        <div class="flex">
          <text-input
            class="text-sm"
            variant="base"
            v-model="verificationOtp"
            :placeholder="$t('frontend_groovemail_import_leads_process_email_verification_enter_otp')"
            :validator="$v.verificationOtp"
          />
        </div>
        <div class="flex justify-end mt-6">
          <gd-button
            size="auto"
            @click="openConfirmationCloseVerfication"
            >{{ $t('frontend_cancel') }}</gd-button
          >
          <gd-button
            variant="primary"
            size="auto"
            @click="verifyEmailWithOtp()"
            class="ml-2"
          >
            {{ $t('frontend_groovemail_import_leads_process_email_verification_btn_text') }}
          </gd-button>
        </div>
      </div>
    </gd-modal>

    <confirm-modal
      :ref="`confirmation-close-verfication`"
      :name="`confirmation-close-verfication`"
      :buttonText="$t('frontend_confirm')"
      :cancelText="$t('frontend_cancel')"
      :confirmMessage="this.$t('frontend_bouses_delete_bonus_title')"
      :messageContent="this.$t('frontend_groovemail_import_leads_process_email_verification_send_mail_are_you_sure')"
      @confirm="confirmationCloseVerfication"
    />
  </div>
</template>

<script>
import axios from 'axios';
import { required, minLength, maxLength, numeric } from 'vuelidate/lib/validators';
import showAlert from '@/components/sweet-alert-popup.js';
import themeConfig from '@/theme/themeConfig';

export default {
  name: 'step3',

  props: {
    model: {
      required: true,
    },
  },

  data() {
    return {
      stepSaved: false,
      verificationOtp: '',
      allEmailsVerified: false,
      currentWebsiteIndex: -1,
      localModel: this.model,
    };
  },

  validations: {
    verificationOtp: {
      required,
      numeric,
      minLength: minLength(4),
      maxLength: maxLength(4),
    },
  },

  methods: {
    validate() {
      this.stepSaved = true;
      let isValid = true;
      if (
        this.localModel.websiteUrls &&
        this.localModel.websiteUrls.length
      ) {
        this.localModel.websiteUrls.forEach(element => {
          if (element.verified !== 1) {
            isValid = false;
          }
        });
      }
      this.allEmailsVerified = isValid;
      this.$emit('on-validate', isValid);
      return isValid;
    },

    emailEntered(index) {
      if (this.localModel.websiteUrls[index].email &&
        this.localModel.websiteUrls[index].email.trim()
      ) {
        this.localModel.websiteUrls[index].sendDisabled = false;
      } else {
        this.localModel.websiteUrls[index].sendDisabled = true;
      }
    },

    async sendVerificationMail(url, index) {
      this.verificationOtp = '';
      this.$v.verificationOtp.$reset();
      this.currentWebsiteIndex = index;
      if (this.localModel.websiteUrls[index].verificationSendMailCount < 5) {
        try {
          this.$emit('showLoader');
          const sendMailResponse = await axios.post('/website-email-verification-send', {
            email: `${url.email}@${url.domain}`,
            website_url: url.urlLink,
          });
          this.localModel.websiteUrls[index].verificationSendMailCount += 1;
          this.localModel.websiteUrls[index].id = sendMailResponse.data.id;
          this.$root.$emit('modal-open', 'email-verification-modal');
          this.$emit('hideLoader');
        } catch (err) {
          this.$emit('hideLoader');
        }
      } else {
        await showAlert({
          iconType: 'alert-error',
          html : `
            <style>.swal2-confirm { color: ${themeConfig.appPrimaryColorInvert} !important; }</style>
            <p class="text-sm text-deep-dark"> ${ this.$t('frontend_groovemail_import_leads_process_email_verification_send_mail_limit_exceeded') }</p>
          `,
          showCancelButton: false,
          showCloseButton: true,
          confirmButtonColor: themeConfig.appPrimaryColor,
          confirmButtonText: this.$t(
            'frontend_close'
          ),
        });
      }
    },

    async verifyEmailWithOtp() {
      this.$v.verificationOtp.$touch();
      if (!this.$v.verificationOtp.$invalid) {
        try {
          this.$emit('showLoader');
          const optResponse = await axios.post('/website-email-otp-verify', {
            // email: `${this.localModel.websiteUrls[this.currentWebsiteIndex].email}@${this.localModel.websiteUrls[this.currentWebsiteIndex].domain}`,
            id: this.localModel.websiteUrls[this.currentWebsiteIndex].id,
            otp: +this.verificationOtp,
          });
          if (optResponse.data.status) {
            this.localModel.websiteUrls[this.currentWebsiteIndex].verified = optResponse.data.status;
            this.$root.$emit('modal-close', 'email-verification-modal');
          } else {
            showAlert({
              iconType: 'alert-error',
              html : `
                <style>.swal2-confirm { color: ${themeConfig.appPrimaryColorInvert} !important; }</style>
                <p class="text-sm text-deep-dark"> ${ optResponse.data.message }</p>
              `,
              showCancelButton: false,
              showCloseButton: true,
              confirmButtonColor: themeConfig.appPrimaryColor,
              confirmButtonText: this.$t(
                'frontend_close'
              ),
            });
          }
          this.$emit('hideLoader');
        } catch (err) {
          this.$emit('hideLoader');
        }
      }
    },

    // open modal to confirm close verfication
    openConfirmationCloseVerfication() {
      this.$refs[`confirmation-close-verfication`].open();
    },

    // close confirm verfication modal
    closeVerficationModal() {
      this.$refs[`confirmation-close-verfication`].close();
    },
    
    // close verfication modal
    confirmationCloseVerfication() {
      // close confirm verfication modal
      this.closeVerficationModal();

      // close email verfication modal
      this.$root.$emit('modal-close', 'email-verification-modal');
    }
  },

  watch: {
    localModel() {
      this.$emit('updateModel', this.localModel);
    },
  },
};
</script>

<style lang="scss">
#email-verification-modal .bg-white.rounded-lg.shadow-2xl.relative.flex.flex-col.overflow-hidden .h-4.w-4.cursor-pointer {
  display: none !important;
}
</style>